import React, { useState, useEffect } from "react";
import { getImageUrl } from "../../../utils/imageUrl";
import configService from "../../../services/configService";

const EYE_ICON_PATH = "shared/assets/icons/eye_outlined.svg";

interface AuditLogsViewButtonProps {
  onClick?: () => void;
}

const AuditLogsViewButton: React.FC<AuditLogsViewButtonProps> = ({
  onClick,
}) => {
  const [imageUrl, setImageUrl] = useState(() =>
    getImageUrl(EYE_ICON_PATH)
  );

  useEffect(() => {
    configService.getConfig().then(() => {
      setImageUrl(getImageUrl(EYE_ICON_PATH));
    });
  }, []);

  return (
    <button
      type="button"
      className="audit-logs-view-btn"
      title="View"
      onClick={onClick}
    >
      <img
        src={imageUrl}
        alt="View"
        onError={(e) => {
          const target = e.target as HTMLImageElement;
          target.style.display = "none";
          const fallback = document.createElement("i");
          fallback.className = "ph-eye";
          target.parentElement?.appendChild(fallback);
        }}
      />
    </button>
  );
};

export default AuditLogsViewButton;
